import { render, staticRenderFns } from "./selectCampo.vue?vue&type=template&id=74490c3b"
import script from "./selectCampo.vue?vue&type=script&lang=ts"
export * from "./selectCampo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports